import { Component, EventEmitter, Input, OnInit, Output, AfterViewInit, OnChanges, SimpleChanges } from '@angular/core';
import { environment } from '@environments/environment';
import { TranslatePipe } from '@pipes/translate.pipe';
import { LocalizationService } from '@services/localization.service';
import { SignOutDialog } from '@app/dialogs/sign-out.dialog';
import { MatDialog } from '@angular/material/dialog';
import { tr } from 'date-fns/locale';
import { DataHelper } from '@helpers/data.helper';

@Component({
  selector: 'account-menu-component',
  templateUrl: './account-menu.component.html',
})
export class AccountMenuComponent {
  accountTabMenu;
  constructor(public _LocalizationService: LocalizationService, public _MatDialog: MatDialog, public _DataHelper: DataHelper) {
    const translator = new TranslatePipe(this._LocalizationService);

    this.accountTabMenu = {
      Slip_Bets: {
        title: translator.transform('Slip_Bets', null),
        tabId: 1,
        extraClass: '',
        projectControl: [], // projede kaldırılmak isteniyorsa buraya proje ismi eklenmeli
        ngIf: () => true,
        order: 1,
        icon: 'my-bets',
        iconClass: '',
        rightMenuIsShow: ['b500', 'cangobet'], // projede right-menu de gözükmesi isteniyorsa proje ismi eklenmeli (projectControl ve ngIf kontrollerinden geçtikten sonra kontrol edilir)
      },
      ArenaPay: {
        title: environment.product === 'wettarena' || environment.product === 'b500' ? 'ArenaPay' : 'PAY3000',
        tabId: 10,
        extraClass: '',
        projectControl: [],
        ngIf: () => this.userHelper.customerUser.IsView === 'True',
        order: 2,
        icon: '',
        iconClass: '',
        rightMenuIsShow: [],
      },
      Credit: {
        title: translator.transform('credit', null),
        tabId: 2,
        extraClass: '',
        projectControl: ['b500', 'cangobet'],
        ngIf: () => true,
        order: 3,
        icon: 'coins',
        iconClass: 'svg-coins',
        rightMenuIsShow: ['wettarena', 'b3000'],
      },
      Bookings: {
        title: translator.transform('bookings', null),
        tabId: 3,
        extraClass: '',
        projectControl: [],
        ngIf: () => true,
        order: 4,
        icon: 'account',
        iconClass: 'svg-account-icon',
        rightMenuIsShow: ['wettarena', 'b3000', 'b500', 'cangobet'],
      },
      CASHBACK: {
        title: translator.transform('CASHBACK', null),
        tabId: 4,
        extraClass: '',
        projectControl: ['b3000', 'wettarena'],
        ngIf: () => true,
        order: 5,
        icon: 'info-circle',
        iconClass: 'svg-info-circle',
        rightMenuIsShow: ['wettarena', 'b3000', 'cangobet', 'b500'],
      },
      Bonus: {
        title: translator.transform('Bonus', null),
        tabId: 9,
        extraClass: '',
        projectControl: ['cangobet'],
        ngIf: () => true,
        order: 6,
        icon: 'account',
        iconClass: 'svg-account-icon',
        rightMenuIsShow: ['wettarena', 'b3000', 'b500'],
      },
      User_Profile: {
        title: translator.transform('User_Profile', null),
        tabId: 5,
        extraClass: '',
        projectControl: [],
        ngIf: () => true,
        order: 7,
        icon: 'user',
        iconClass: 'svg-user-icon',
        rightMenuIsShow: ['wettarena', 'b3000', 'b500', 'cangobet'],
      },
      limits_bans: {
        title: translator.transform('limits_bans', null),
        tabId: 6,
        extraClass: '',
        projectControl: [],
        ngIf: () => this._DataHelper.selectedWallet.BranchType !== 0,
        order: 8,
        icon: 'lock',
        iconClass: 'svg-lock',
        rightMenuIsShow: ['wettarena', 'b3000', 'b500', 'cangobet'],
      },
      document_upload: {
        title: translator.transform('document_upload', null),
        tabId: 7,
        extraClass: '',
        projectControl: [],
        ngIf: () => true,
        order: 9,
        icon: 'file',
        iconClass: 'svg-file-icon',
        rightMenuIsShow: ['wettarena', 'b3000', 'b500', 'cangobet'],
      },
      Verifications: {
        title: translator.transform('Verifications', null),
        tabId: 8,
        extraClass: '',
        projectControl: [],
        ngIf: () => this._DataHelper.selectedWallet.BranchType == 1,
        order: 10,
        icon: '',
        iconClass: '',
        rightMenuIsShow: [],
      },
      Verification_SOW: {
        title: translator.transform('Verification_SOW', null),
        tabId: 11,
        extraClass: '',
        projectControl: ['b500', 'cangobet', 'wettarena-pl', 't90', 'betarena', 'terminalPeru'],
        ngIf: () => true,
        order: 11,
        icon: 'creditworthiness',
        iconClass: '',
        rightMenuIsShow: ['wettarena', 'b3000'],
      },
    };
  }

  @Input() menuSelect: string;
  @Input() userHelper: any;
  @Input() UiHelper: any;

  accountTabMenuRebuild(
    values: {
      [key: string]: {
        title: string;
        tabId: number;
        extraClass: string;
        projectControl: string[];
        ngIf: () => boolean;
        order: number;
        rightMenuIsShow: string[];
        icon: string;
        iconClass: string;
      };
    },
    isRightMenu = false
  ) {
    return Object.values(values)
      .filter(item =>
        isRightMenu
          ? item.ngIf() && !item.projectControl.includes(environment.product) && item.rightMenuIsShow.includes(environment.product)
          : item.ngIf() && !item.projectControl.includes(environment.product)
      )
      .sort((a, b) => a.order - b.order);
  }
  changeSelectMenu(selectMenu: number) {
    this.UiHelper.accountMobileMenu = selectMenu;
  }

  OpenAccountMobile(selectMenu) {
    this.UiHelper.b3000SetAcountMobileState('open', selectMenu);
    this.UiHelper.b3000SetRightMenuState('close');
  }

  SignOutDialogOpener(x) {
    const dialogRef = this._MatDialog;
    if (x) {
      this.UiHelper.closeAllMenus();
      dialogRef
        .open(SignOutDialog, {
          width: '350px',
        })
        .afterClosed()
        .subscribe(result => {
          this.UiHelper.closeDimmer();
          //////console.log('The dialog was closed' + result);
        });
    } else {
      dialogRef.closeAll();
    }
    // dialogRef.componentInstance.data = purpose;
  }
}
